import { QueryClient } from '@tanstack/react-query';

// Single shared React Query client. Lives outside main.tsx so non-component
// code (auth store logout, etc.) can clear cached data on sign-out —
// otherwise one member's cached data could be served to the next member
// signing in on the same browser.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 30, // 30 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
